export default __webpack_public_path__ + "static/media/stadt-mosbach-logo.6f2fde93.svg";